import { c as _c } from "react/compiler-runtime";
import { styled } from '@classify/react-core-components/styles';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import { translate } from '@openclassrooms/translations';
import Button from '@classify/react-core-components/Button';
import IconButton from '@classify/react-core-components/IconButton';
import { ContactButton } from './ContactButton';
export { default as useHelpTypeFromPathname } from './ContactButton/ContactProvider/useHelpTypeFromPathname';
const ButtonsContainer = styled('div')(({
  theme: {
    breakpoints
  }
}) => ({
  '& .headerContactButton--small': {
    display: 'inline-flex'
  },
  '& .headerContactButton--regular': {
    display: 'none'
  },
  [breakpoints.up('lg')]: {
    '& .headerContactButton--small': {
      display: 'none'
    },
    '& .headerContactButton--regular': {
      display: 'inline-flex'
    }
  }
}));
export function HeaderContactButton() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <ContactButton render={_temp} />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}
function _temp(t0) {
  const {
    onClick
  } = t0;
  return <ButtonsContainer><IconButton className="headerContactButton--small" tooltip={translate("main_header.support")} aria-label={translate("main_header.support")} onClick={onClick} data-event="header|click|contact-us|button"><HelpOutlineIcon sx={{
        width: 28,
        height: 28
      }} /></IconButton><Button className="headerContactButton--regular" data-event="header|click|contact-us|button" variant="secondary" onClick={onClick}>{translate("main_header.support")}</Button></ButtonsContainer>;
}